import React from 'react';
import './NoticeList.css';

const NoticeList = ({ notices, filter, onFilterChange, onNoticeSelect, onSignNotice }) => {
  const getStatusText = (notice) => {
    const hasUnsigned = notice.studentResponses.some(response => !response.signed);
    if (hasUnsigned) {
      return '未簽';
    }
    return '已簽';
  };

  const getStatusClass = (notice) => {
    const hasUnsigned = notice.studentResponses.some(response => !response.signed);
    if (hasUnsigned) {
      return 'status-unsigned';
    }
    return 'status-signed';
  };

  const getDateDisplay = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) {
      return '今天';
    } else if (diffDays === 1) {
      return '昨天';
    } else if (diffDays <= 7) {
      return `${diffDays}天前`;
    } else {
      return date.toLocaleDateString('zh-HK');
    }
  };

  const isExpired = (deadline) => {
    const deadlineDate = new Date(deadline);
    const today = new Date();
    return deadlineDate < today;
  };

  return (
    <div className="notice-list-container">
      {/* Filter Tabs */}
      <div className="filter-tabs">
        <button
          className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
          onClick={() => onFilterChange('all')}
        >
          全部
        </button>
        <button
          className={`filter-tab ${filter === 'unsigned' ? 'active' : ''}`}
          onClick={() => onFilterChange('unsigned')}
        >
          未簽
        </button>
        <button
          className={`filter-tab ${filter === 'signed' ? 'active' : ''}`}
          onClick={() => onFilterChange('signed')}
        >
          已簽
        </button>
      </div>

      {/* Notices List */}
      <div className="notices-list">
        {notices.length === 0 ? (
          <div className="no-notices">
            <p>暫無電子通告</p>
          </div>
        ) : (
          notices.map((notice) => (
            <div key={notice.id} className="notice-item">
              <div className="notice-content" onClick={() => onNoticeSelect(notice)}>
                <div className="notice-header">
                  <h3 className="notice-title">{notice.title}</h3>
                  <span className={`notice-status ${getStatusClass(notice)}`}>
                    {getStatusText(notice)}
                  </span>
                </div>
                
                <div className="notice-meta">
                  <span className="notice-date">
                    {getDateDisplay(notice.publishDate)}
                  </span>
                  {isExpired(notice.responseDeadline) && (
                    <span className="notice-expired">已過期</span>
                  )}
                </div>

                <div className="notice-preview">
                  {notice.content.length > 100 
                    ? `${notice.content.substring(0, 100)}...` 
                    : notice.content
                  }
                </div>
              </div>

              <div className="notice-actions">
                {!isExpired(notice.responseDeadline) && 
                 notice.studentResponses.some(response => !response.signed) && (
                  <button
                    className="sign-button"
                    onClick={() => onSignNotice(notice)}
                  >
                    簽署
                  </button>
                )}
                {notice.studentResponses.some(response => response.signed) && (
                  <span className="signed-indicator">✓ 已簽署</span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NoticeList;
